export default __webpack_public_path__ + "static/media/Sachin.967f165c.jpeg";